export default "__VITE_ASSET__D$eVrmR4__"